import { Box, Tab, Tabs } from "@mui/material";

import { MODEL_PROPTYPES } from "../../models";
import { PARCELLAIRE_TAB_BOX_STYLE } from "./constants";
import { ParcellaireCreationFormImport } from "./ParcellaireCreationFormImport";
import { ParcellaireCreationFormNoImport } from "./ParcellaireCreationFormNoImport";
import { ParcellaireCreationFromCloverfield } from "./ParcellaireCreationFromCloverfield";
import { ParcellaireHCCLoadForm } from "./ParcellaireHCCLoadForm";
import PropTypes from "prop-types";
import { TabPanel } from "../../components";
import { useState } from "react";

ParcellaireCreationContainer.propTypes = {
    coordMarkerMode: PropTypes.bool.isRequired,
    map: PropTypes.any,
    parcellaireState: PropTypes.object.isRequired,
    parcellaireDispatch: PropTypes.func.isRequired,
    setBlueRectangleData: PropTypes.func.isRequired,
    setCoordMarkerMode: PropTypes.func.isRequired,
    setGeoJsonKey: PropTypes.func.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    setSelectableMetadata: PropTypes.func.isRequired,
    initialCompany: PropTypes.shape(MODEL_PROPTYPES.Company),
    initialContract: PropTypes.shape(MODEL_PROPTYPES.Contract),
    initialSite: PropTypes.shape(MODEL_PROPTYPES.Site),
    initialMission: PropTypes.shape(MODEL_PROPTYPES.Mission),
    crops: PropTypes.arrayOf(PropTypes.shape(MODEL_PROPTYPES.CROP)).isRequired,
    setSearchParams: PropTypes.func.isRequired,
    hasInitialMission: PropTypes.bool,
};

export function ParcellaireCreationContainer({
    coordMarkerMode,
    map,
    parcellaireState,
    parcellaireDispatch,
    setBlueRectangleData,
    setCoordMarkerMode,
    setGeoJsonKey,
    setIsOpen,
    setSelectableMetadata,
    initialCompany,
    initialContract,
    initialSite,
    initialMission,
    crops,
    setSearchParams,
    hasInitialMission = false,
}) {
    const [tabValue, setTabValue] = useState(0);

    const handleChange = (_, newValue) => {
        setTabValue(newValue);
    };

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    sx={{ flexGrow: 1 }}
                >
                    <Tab label="From Cloverfield" />
                    <Tab label="From HCC" />
                    <Tab label="From Scratch" />
                    <Tab label="From Files" />
                </Tabs>
            </Box>
            <TabPanel
                value={tabValue}
                index={0}
                boxStyle={PARCELLAIRE_TAB_BOX_STYLE}
            >
                <ParcellaireCreationFromCloverfield
                    map={map}
                    parcellaireDispatch={parcellaireDispatch}
                    setBlueRectangleData={setBlueRectangleData}
                    setGeoJsonKey={setGeoJsonKey}
                    setIsOpen={setIsOpen}
                    setSelectableMetadata={setSelectableMetadata}
                    crops={crops}
                    initialCompany={initialCompany}
                    initialContract={initialContract}
                    initialSite={initialSite}
                    hasInitialMission={hasInitialMission}
                />
            </TabPanel>
            <TabPanel
                value={tabValue}
                index={1}
                boxStyle={PARCELLAIRE_TAB_BOX_STYLE}
            >
                <ParcellaireHCCLoadForm
                    setIsOpen={setIsOpen}
                    parcellaireState={parcellaireState}
                    parcellaireDispatch={parcellaireDispatch}
                    map={map}
                    setGeoJsonKey={setGeoJsonKey}
                    initialCompany={initialCompany}
                    initialContract={initialContract}
                    initialSite={initialSite}
                    initialMission={initialMission}
                    setSelectableMetadata={setSelectableMetadata}
                    setSearchParams={setSearchParams}
                />
            </TabPanel>

            <TabPanel
                value={tabValue}
                index={2}
                boxStyle={{ p: (theme) => theme.spacing(3, 0, 0, 0) }}
            >
                <ParcellaireCreationFormNoImport
                    coordMarkerMode={coordMarkerMode}
                    map={map}
                    parcellaireDispatch={parcellaireDispatch}
                    setBlueRectangleData={setBlueRectangleData}
                    setCoordMarkerMode={setCoordMarkerMode}
                    setGeoJsonKey={setGeoJsonKey}
                    setIsOpen={setIsOpen}
                    setSelectableMetadata={setSelectableMetadata}
                />
            </TabPanel>
            <TabPanel
                value={tabValue}
                index={3}
                boxStyle={PARCELLAIRE_TAB_BOX_STYLE}
            >
                <ParcellaireCreationFormImport
                    map={map}
                    parcellaireDispatch={parcellaireDispatch}
                    setBlueRectangleData={setBlueRectangleData}
                    setGeoJsonKey={setGeoJsonKey}
                    setIsOpen={setIsOpen}
                    setSelectableMetadata={setSelectableMetadata}
                    crops={crops}
                />
            </TabPanel>
        </>
    );
}
